import { createSelector } from 'reselect'
import { sumBy } from 'lodash'

const selectSubOrder = state => state.screens.SubOrder.subOrder

export default createSelector(
  selectSubOrder,
  (subOrder) => {

    const total = subOrder.sub_order_groups.reduce((carry, subOrderGroup) => {
      return carry + (sumBy(subOrderGroup.sub_order_items, 'total') || 0)
    }, 0)

    // Recalculate set_amount based on set_percentage if it exists
    // set_amount is a percentage of the net total (not including VAT)
    const setAmount = subOrder.set_percentage !== null && subOrder.set_percentage !== undefined
      ? (total / 100) * subOrder.set_percentage
      : subOrder.set_amount

    return { 
      total,
      setAmount,
      setPercentage: subOrder.set_percentage,
    }

  },
)
